import { Resource as TResource } from "@/types";

import Resource from "./Resource";

const Resources = ({ resources }: { resources?: TResource[] }) => {
  if (!resources?.length) {
    console.error("No resources");
    return null;
  }

  return (
    <div className="gap-md grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
      {resources?.map((resource) => {
        return <Resource key={resource.url} resource={resource} />;
      })}
    </div>
  );
};

export default Resources;
